import { FC, useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { Status } from "../../../../Entities";
import { IoIosArrowForward } from "react-icons/io";
import { dataContext } from "../../../../Context";
import { Idomain } from "../../../../Interfaces";
import "./Theme.css";

interface StatusLocal {
  [key: string]: string;
}

interface IThemeProps {
  listDomain: Set<string>;
  tribu: string;
  data: Idomain[];
  setEnableScore: React.Dispatch<React.SetStateAction<string>>;
}
const EXPERTISE_DOMAIN_INDEX = 6;
const STATUS_FORM = "StatusForm";
const firstLetter = 0;
const dropFirstLetter = 1;

interface IIcon {
  tribe: string;
  icon: string;
  expertise: string;
}

const status: StatusLocal = {
  to_do: "A FAIRE",
  in_progress: "EN COURS",
  done: "FINI",
};

enum StatutEnum {
  "A_FAIRE" = "to_do",
  "EN_COURS" = "in_progress",
  "FINI" = "done",
}

const Theme: FC<IThemeProps> = ({
  listDomain,
  tribu,
  data,
  setEnableScore,
}) => {
  const [userProgression, setUserProgession] = useState<Status[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const storage: string | null = localStorage.getItem(STATUS_FORM);
  const { rawData, loadingData, icons } = useContext(dataContext);
  const history = useHistory();
  const token = localStorage.getItem("idToken")

  const parseIconsIntoObject: IIcon[] = icons.map((row: string[][]) => {
    return {
      tribe: row[0],
      icon: row[1],
      expertise: row[2],
    };
  });

  const getUserCompletion = (
    resultData: string[][],
    dataToCompare: Idomain[]
  ) => {
    if (resultData) {
      const status = Array.from(dataToCompare).map((value) => {
        //filter on expertise domain
        const filterByStatut = resultData.filter((data: string[]) => {
          return value.name === data[EXPERTISE_DOMAIN_INDEX];
        });

        let progression = StatutEnum.A_FAIRE;
        const length = filterByStatut.length;

        if (length) {
          progression = StatutEnum.EN_COURS;
          if (value.value === length) {
            progression = StatutEnum.FINI;
          }
        }

        return new Status(value.name, progression, value.value, length);
      });

      const orderByStatus = displayStatusByOrder(status);

      return orderByStatus;
    }
  };

  const parsingDomainIntoObject = () => {
    const statusArray = Array.from(listDomain).map((value: string) => {
      return new Status(value, StatutEnum.A_FAIRE, 0, 0);
    });
    const orderedStatus = displayStatusByOrder(statusArray);

    setUserProgession(orderedStatus);
    localStorage.setItem(STATUS_FORM, JSON.stringify(statusArray));
    setIsLoading(false);
  };

  //sorting by status
  const displayStatusByOrder = (arrayToSort: Status[]) => {
    arrayToSort.map((item, index) => {
      if (item.status === StatutEnum.A_FAIRE) {
        item.status = "1";
      }
      if (item.status === StatutEnum.EN_COURS) {
        item.status = "0";
      }
      if (item.status === StatutEnum.FINI) {
        item.status = "2";
      }
      return arrayToSort;
    });

    arrayToSort
      .sort((a: Status, b: Status) => parseInt(a.status) - parseInt(b.status))
      .forEach((progression: Status) => {
        switch (progression.status) {
          case "1":
            progression.status = StatutEnum.A_FAIRE;
            break;
          case "2":
            progression.status = StatutEnum.FINI;
            break;
          default:
            progression.status = StatutEnum.EN_COURS;
        }
      });

    return arrayToSort;
  };

  //enable button result
  const enableResultPage = (
    storage: string | null,
    userCompletion: Status[]
  ) => {
    if (storage) {
      const jsonStorage = JSON.parse(storage);
      const storageComparaison = jsonStorage.filter((object: Status) => {
        return object.status === "done";
      });

      if (storageComparaison.length === userCompletion.length) {
        return setEnableScore("enable");
      }
      return setEnableScore("disable");
    }
  };

  const capitalizeFirstLetter = (str: string) => {
    if (str) {
      return str
        .toLowerCase()
        .split(" ")
        .map(
          (word) =>
            word.charAt(firstLetter).toUpperCase() + word.slice(dropFirstLetter)
        )
        .join(" ");
    }
  };

  useEffect(() => {
    if (!storage || rawData) {
      if (rawData && data.length) {
        if (storage) {
          const displayByStatus = displayStatusByOrder(JSON.parse(storage));
          setUserProgession(displayByStatus);
          setIsLoading(false);
        } else {
          const newUser = getUserCompletion(rawData, data);
          if (newUser) {
            setUserProgession(newUser);
            localStorage.setItem(STATUS_FORM, JSON.stringify(newUser));
            setIsLoading(false);
          }
        }
      }
      if (!storage && !rawData) {
        if (listDomain.size !== 0) {
          parsingDomainIntoObject();
        }
        setIsLoading(false);
      }
    } else {
      const statusForm = JSON.parse(storage);
      const parse = displayStatusByOrder(statusForm);

      setUserProgession(parse);
      localStorage.setItem(STATUS_FORM, JSON.stringify(statusForm));
      setIsLoading(false);
    }

    // eslint-disable-next-line
  }, [data, rawData, loadingData]);

  useEffect(() => {
    if (!token) {
      history.push("/");
    }
  });

  const statusBorderCss = (status: string) => {
    return { border: `themeProgress_${status}`, status: `themeLine_${status}` };
  };

  //set LocalStorage
  const handleOnClick = (index: number) => {
    const userProgressionUpdated = userProgression.map(
      (progression: Status, key: number) => {
        if (index === key) {
          return {
            ...progression,
            status: StatutEnum.EN_COURS,
          } as Status;
        }
        return progression;
      }
    );

    setUserProgession(userProgressionUpdated);
  };

  const renderView = (userData: Status[]) => {
    enableResultPage(storage, userData);

    const render = userData.map((item: Status, index: number) => {
      const icon = parseIconsIntoObject.find((data: IIcon) => {
        return item.expertise === data.expertise;
      });

      const itemStatus: string = item.status.toString();
      const statusRender = status[itemStatus];

      return (
        <li className={statusBorderCss(itemStatus).status} key={index}>
          <Link
            to={`/tribu/${tribu}/${item.expertise}`}
            className="themeLink"
            onClick={() => {
              handleOnClick(index);
            }}
          >
            <div className="themeHeader">
              <p className="emoji">{icon!.icon}</p>
              <div className="themeText">
                <p className="themeTextDomain">
                  <strong>{capitalizeFirstLetter(item.expertise)}</strong>{" "}
                </p>
                <p className="themeTextPercent">{`${
                  !item.completion ? "0" : item.completion
                }%`}</p>
              </div>
            </div>
            <div className="statusDisplay">
              <div className={statusBorderCss(itemStatus).border}>
                <strong className="statusStrong">{statusRender}</strong>
              </div>
              <IoIosArrowForward></IoIosArrowForward>
            </div>
          </Link>
        </li>
      );
    });
    return render;
  };

  return (
    <ul className="ExpertiseList">
      {isLoading ? <p>loading</p> : renderView(userProgression)}
    </ul>
  );
};

export default Theme;
